export const LOCAL_STORAGE_KEYS = {
  LOCALE: 'dbm.locale',
  HOME_OPTIONS: 'dbm.home.options',
  SPOT_OPTIONS: 'dbm.spot.options',
  FORWARD_OPTIONS: 'dbm.forward.options',
  SETTLEMENT_OPTIONS: 'dbm.settlement.options',
};